/* VanillaGoods Kids Kitchen, Phases 2 to 4: videos, activity tabs, level filters, Baking Math, Birthday Baking
   Workshop, hub "this week" cards, printables (word search, shapes, Print), recipe-box step mode and kids' print card.
   Privacy: nothing is sent anywhere. Videos load from youtube-nocookie.com only after a click. The only thing kept is
   the last lesson number in this browser (localStorage) so the hub can suggest the next lesson.
   ASCII only: emoji are written as \u escapes. */
(function () {
  'use strict';

  var BANDS = { little_helpers: 'Little Helpers', junior_bakers: 'Junior Bakers', rising_chefs: 'Rising Chefs', all: 'All levels' };
  var CATS = ['My First Kitchen Lesson', 'Measuring and Mixing', 'Bake With Me', 'Fun Food Science', 'Decorating School', 'Young Chef Spotlight'];
  var cache = {};

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function getJSON(url) {
    if (!url) return Promise.resolve(null);
    if (!cache[url]) cache[url] = fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    return cache[url];
  }
  function store(k, v) { try { if (v === undefined) return window.localStorage.getItem(k); window.localStorage.setItem(k, v); } catch (e) { return null; } }
  function track(name, params) { try { if (window.vgTrack) window.vgTrack(name, params || {}); } catch (e) { /* none */ } }
  function isoWeek(d) {
    var t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    var day = t.getUTCDay() || 7; t.setUTCDate(t.getUTCDate() + 4 - day);
    var y0 = new Date(Date.UTC(t.getUTCFullYear(), 0, 1));
    return Math.ceil(((t - y0) / 86400000 + 1) / 7);
  }
  function seeded(seed) {  // mulberry32
    var a = 0; for (var i = 0; i < seed.length; i++) a = (a * 31 + seed.charCodeAt(i)) | 0;
    return function () { a |= 0; a = (a + 0x6D2B79F5) | 0; var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
  }
  function mins(m) { m = Number(m) || 0; return m >= 120 ? Math.round(m / 60) + ' hr' : m + ' min'; }

  /* ---------------- videos (click-to-load, youtube-nocookie) ---------------- */
  /* The video's own cover picture from i.ytimg.com (cookieless image host, no referrer), like the Baking Academy.
     The video itself loads only when a grown-up presses Play (youtube-nocookie). */
  function thumb(id, size, cls) {
    var w = size === 'mqdefault' ? 320 : 480, h = size === 'mqdefault' ? 180 : 360;
    return '<img class="' + cls + '" src="https://i.ytimg.com/vi/' + encodeURIComponent(id) + '/' + size + '.jpg" alt="" ' +
      'loading="lazy" decoding="async" referrerpolicy="no-referrer" width="' + w + '" height="' + h + '">';
  }
  function videoCard(v) {
    return '<li class="kk-video"><div class="kk-video__frame">' + thumb(v.id, 'hqdefault', 'kk-video__thumb') +
      '<button type="button" class="kk-video__play" data-kk-play="' + esc(v.id) + '" aria-label="Play video: ' + esc(v.title) + '">' +
      '<span class="kk-video__icon" aria-hidden="true">\u25b6</span><span>Play video</span></button></div>' +
      '<div class="kk-video__body"><h3>' + esc(v.title) + '</h3><p>By ' + esc(v.channel) + ' \u00b7 ' + esc(v.minutes) + ' min</p></div></li>';
  }
  function linkCard(v) {
    return '<a class="kk-linkcard" href="https://www.youtube.com/watch?v=' + encodeURIComponent(v.id) + '" target="_blank" rel="noopener">' +
      thumb(v.id, 'mqdefault', 'kk-linkcard__thumb') + '<span>' +
      '<b>For grown-ups: watch on YouTube</b><br>' + esc(v.title) + ' \u00b7 ' + esc(v.channel) + ' \u00b7 ' + esc(v.minutes) + ' min</span></a>';
  }
  function bindPlay(box) {
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-kk-play]');
      if (!b) return;
      var id = b.getAttribute('data-kk-play');
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
      f.title = b.getAttribute('aria-label') || 'Video';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.referrerPolicy = 'strict-origin-when-cross-origin';
      b.parentNode.replaceChild(f, b);
      track('kk_video_play', { category: 'video' });
    });
  }
  function videos() {
    $$('[data-kk-videos]').forEach(function (box) {
      getJSON(box.getAttribute('data-kk-videos')).then(function (d) {
        var all = ((d && d.videos) || []).filter(function (v) { return v.ok !== false; });
        var lesson = box.getAttribute('data-lesson'), science = box.getAttribute('data-science'), recipe = box.getAttribute('data-recipe');
        var pick = function (v) {
          if (lesson) return (v.lessons || []).indexOf(lesson) >= 0;
          if (science) return (v.science || []).indexOf(science) >= 0;
          if (recipe) return (v.recipes || []).indexOf(recipe) >= 0;
          return true;
        };
        var embeds = all.filter(function (v) { return pick(v) && v.kind === 'embed' && v.made_for_kids; });
        var links = all.filter(function (v) { return pick(v) && v.kind === 'grownup_link'; });
        if (box.hasAttribute('data-grouped')) {
          var html = '';
          CATS.forEach(function (c) {
            var vs = embeds.filter(function (v) { return v.category === c; });
            if (vs.length) html += '<h2>' + esc(c) + '</h2><ul class="kk-videos">' + vs.map(videoCard).join('') + '</ul>';
          });
          box.innerHTML = html;
        } else if (embeds.length) {
          box.innerHTML = '<h2>' + esc(box.getAttribute('data-heading') || 'Watch and learn') + '</h2><ul class="kk-videos">' + embeds.map(videoCard).join('') + '</ul>';
        }
        var g = $('[data-kk-grownup-links]');
        if (g && links.length && !box.hasAttribute('data-grouped')) { g.innerHTML = links.map(linkCard).join(''); g.hidden = false; }
        if (embeds.length) { box.hidden = false; bindPlay(box); }
      }).catch(function () { /* videos are optional */ });
    });
  }

  /* ---------------- tabs and level filters ---------------- */
  function tabs() {
    $$('[data-kk-tabs]').forEach(function (bar) {
      var btns = $$('button[aria-controls]', bar);
      function show(id) {
        btns.forEach(function (b) {
          var on = b.getAttribute('aria-controls') === id;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          var p = document.getElementById(b.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('aria-controls')); history.replaceState(null, '', '#' + b.getAttribute('data-tab')); }); });
      var want = (location.hash || '').slice(1);
      var first = btns.filter(function (b) { return b.getAttribute('data-tab') === want; })[0] || btns[0];
      if (first) show(first.getAttribute('aria-controls'));
    });
  }
  function levelFilters() {
    $$('[data-kk-levelfilter]').forEach(function (form) {
      var scope = document.getElementById(form.getAttribute('data-kk-levelfilter')) || document;
      function apply() {
        var v = (form.querySelector('input:checked') || {}).value || '';
        $$('[data-level]', scope).forEach(function (el) {
          var l = el.getAttribute('data-level');
          el.hidden = !!v && l !== v && l !== 'all';
        });
      }
      form.addEventListener('change', apply);
      apply();
    });
  }

  /* ---------------- hub: next lesson, this week's challenge, weekend plan ---------------- */
  function itemCard(it, kind) {
    return '<div class="kk-item"><div class="kk-item__top"><span class="kk-num">' + esc(String(it.number).replace(/^(\d)$/, '0$1')) + '</span>' +
      '<div><span class="kk-badge">' + esc(kind) + '</span>' + (it.minutes ? '<span class="kk-badge">' + mins(it.minutes) + '</span>' : '') + '</div></div>' +
      '<h3><a href="' + esc(it.url) + '">' + esc(it.title) + '</a></h3><p>' + esc(it.summary || '') + '</p></div>';
  }
  function hub() {
    var box = $('[data-kk-weekly]');
    if (!box) return;
    Promise.all([getJSON(box.getAttribute('data-kk-learn')), getJSON(box.getAttribute('data-kk-recipes'))]).then(function (r) {
      var L = r[0] || {}, R = ((r[1] && r[1].recipes) || []);
      var lessons = (L.lessons || []).slice().sort(function (a, b) { return a.number - b.number; });
      var ch = (L.challenges || []).slice().sort(function (a, b) { return a.number - b.number; });
      var acts = (L.science || []).concat(L.challenges || [], L.printables || []);
      if (!lessons.length && !ch.length) return;
      var week = isoWeek(new Date());
      var last = parseInt(store('kk_last_lesson') || '0', 10) || 0;
      var next = lessons.filter(function (l) { return l.number > last; })[0] || lessons[0];
      var html = '';
      if (next) html += '<div><h3 style="margin:0 0 10px">' + (last ? 'Your next kitchen skill' : 'Learn a new kitchen skill') + '</h3>' + itemCard(next, 'Lesson') + '</div>';
      if (ch.length) html += '<div><h3 style="margin:0 0 10px">This week\u2019s baking challenge</h3>' + itemCard(ch[week % ch.length], 'Challenge') + '</div>';
      html += '<div><h3 style="margin:0 0 10px">Plan a weekend bake</h3><div class="kk-item" data-kk-plan>' +
        '<div class="kk-chips" role="radiogroup" aria-label="Baking level">' +
        ['little_helpers', 'junior_bakers', 'rising_chefs'].map(function (b, i) {
          return '<label class="kk-chip"><input type="radio" name="kk-plan-band" value="' + b + '"' + (i === 1 ? ' checked' : '') + '><span>' + BANDS[b] + '</span></label>';
        }).join('') + '</div><div data-kk-plan-out></div><p><button type="button" class="kk-btn kk-btn--light" data-kk-shuffle>Shuffle</button></p></div></div>';
      box.querySelector('[data-kk-weekly-grid]').innerHTML = html;
      box.hidden = false;
      var shuffle = 0, planBox = box.querySelector('[data-kk-plan]');
      function fits(x, band) { return !x.level || x.level === 'all' || x.level === band; }
      function plan() {
        var band = (planBox.querySelector('input:checked') || {}).value || 'junior_bakers';
        var rnd = seeded(band + ':' + week + ':' + shuffle);
        function one(list) { return list.length ? list[Math.floor(rnd() * list.length)] : null; }
        var rec = one(R.filter(function (x) { return x.band === band; }));
        var les = one(lessons.filter(function (x) { return fits(x, band); }));
        var act = one(acts.filter(function (x) { return fits(x, band); }));
        var out = '<ul class="kk-list">';
        if (rec) out += '<li><b>Bake:</b> <a href="' + esc(rec.url) + '">' + esc(rec.title) + '</a></li>';
        if (les) out += '<li><b>Learn:</b> <a href="' + esc(les.url) + '">' + esc(les.title) + '</a></li>';
        if (act) out += '<li><b>Play:</b> <a href="' + esc(act.url) + '">' + esc(act.title) + '</a></li>';
        planBox.querySelector('[data-kk-plan-out]').innerHTML = out + '</ul>';
      }
      planBox.addEventListener('change', function () { shuffle = 0; plan(); });
      planBox.querySelector('[data-kk-shuffle]').addEventListener('click', function () { shuffle++; plan(); });
      plan();
    }).catch(function () { /* the hub works without these cards */ });
  }
  function rememberLesson() {
    var a = $('[data-kk-type="lesson"][data-kk-number]');
    if (!a) return;
    var n = parseInt(a.getAttribute('data-kk-number'), 10), last = parseInt(store('kk_last_lesson') || '0', 10) || 0;
    if (n > last) store('kk_last_lesson', String(n));
    track('kk_lesson_view', { lesson: n });
  }

  /* ---------------- Baking Math Adventures ---------------- */
  function norm(s) { return String(s == null ? '' : s).toLowerCase().replace(/[\s.,!]+$/g, '').replace(/\s+/g, ' ').trim(); }
  function math() {
    var box = $('[data-kk-math]');
    if (!box) return;
    getJSON(box.getAttribute('data-kk-math')).then(function (d) {
      var ps = ((d && d.problems) || []).slice().sort(function (a, b) { return a.number - b.number; });
      if (!ps.length) return;
      box.innerHTML = ps.map(function (p, i) {
        var id = 'kk-m' + i;
        return '<article class="kk-item" data-level="' + esc(p.level || 'all') + '"><div class="kk-item__top"><span class="kk-num">' + esc(p.number) + '</span>' +
          '<div><span class="kk-badge">' + esc(BANDS[p.level] || 'All levels') + '</span>' + (p.type ? '<span class="kk-badge">' + esc(p.type) + '</span>' : '') + '</div></div>' +
          '<h3>' + esc(p.title) + '</h3><p>' + esc(p.story) + '</p><p class="kk-q">' + esc(p.question) + '</p>' +
          '<form class="kk-row" data-i="' + i + '"><label class="visually-hidden" for="' + id + '">Your answer</label>' +
          '<input type="text" id="' + id + '" autocomplete="off" placeholder="Your answer"><button class="kk-btn" type="submit">Check</button>' +
          '<button class="kk-btn kk-btn--light" type="button" data-hint>Hint</button><button class="kk-btn kk-btn--light" type="button" data-how>Show how</button></form>' +
          '<p class="kk-result" aria-live="polite"></p><p data-hint-text hidden>' + esc(p.hint) + '</p><p data-how-text hidden>' + esc(p.explanation) +
          ' <b>Answer: ' + esc(p.answer) + '</b></p>' +
          (p.recipe ? '<p><a href="/blogs/recipes/' + esc(p.recipe) + '">See the recipe</a> \u00b7 <a href="/pages/recipe-scaling-calculator">Recipe scaler</a></p>' : '') + '</article>';
      }).join('');
      box.addEventListener('submit', function (e) {
        e.preventDefault();
        var f = e.target, p = ps[+f.getAttribute('data-i')], v = norm(f.querySelector('input').value);
        var ok = [p.answer].concat(p.accept || []).some(function (a) { return norm(a) === v; });
        var out = f.parentNode.querySelector('.kk-result');
        out.textContent = !v ? 'Type an answer first.' : ok ? 'Yes! That\u2019s right.' : 'Not quite. Try again or tap Hint.';
        out.className = 'kk-result ' + (v ? (ok ? 'kk-result--ok' : 'kk-result--no') : '');
        if (v) track('kk_math_check', { correct: ok });
      });
      box.addEventListener('click', function (e) {
        var art = e.target.closest('article'); if (!art) return;
        if (e.target.closest('[data-hint]')) art.querySelector('[data-hint-text]').hidden = false;
        if (e.target.closest('[data-how]')) art.querySelector('[data-how-text]').hidden = false;
      });
      box.hidden = false;
      levelFilters();
    }).catch(function () { box.innerHTML = '<p class="kk-empty">The math problems could not load right now.</p>'; box.hidden = false; });
  }

  /* ---------------- Birthday Baking Workshop ---------------- */
  var FR = { '\u00bc': 0.25, '\u00bd': 0.5, '\u00be': 0.75, '\u2153': 1 / 3, '\u2154': 2 / 3, '\u215b': 0.125 };
  function parseQty(line) {
    var m = String(line).match(/^\s*((?:\d+\s+)?\d+\/\d+|\d+(?:\.\d+)?|[\u00bc\u00bd\u00be\u2153\u2154\u215b])(\s*[\u00bc\u00bd\u00be\u2153\u2154\u215b])?\s+(.*)$/);
    if (!m) return null;
    var q = 0, t = m[1].trim();
    if (FR[t] != null) q = FR[t];
    else if (t.indexOf('/') > 0) { var parts = t.split(/\s+/), f = parts.pop().split('/'); q = (parts.length ? +parts[0] : 0) + (+f[0] / +f[1]); }
    else q = parseFloat(t);
    if (m[2]) q += FR[m[2].trim()] || 0;
    return { q: q, rest: m[3] };
  }
  function fmtQty(q) {
    var w = Math.floor(q + 1e-9), f = q - w, names = [[0.125, '1/8'], [0.25, '1/4'], [1 / 3, '1/3'], [0.5, '1/2'], [2 / 3, '2/3'], [0.75, '3/4']];
    var best = null;
    names.forEach(function (n) { if (Math.abs(f - n[0]) < 0.05) best = n[1]; });
    if (f < 0.05) return String(w);
    if (f > 0.95) return String(w + 1);
    return best ? (w ? w + ' ' : '') + best : (Math.round(q * 10) / 10).toString();
  }
  function party() {
    var box = $('[data-kk-party]');
    if (!box) return;
    Promise.all([getJSON(box.getAttribute('data-kk-party')), getJSON(box.getAttribute('data-kk-recipes')),
                 getJSON(box.getAttribute('data-kk-learn')).catch(function () { return {}; })]).then(function (r) {
      var themes = (r[0] && r[0].themes) || [], recipes = {}, printables = {};
      ((r[2] && r[2].printables) || []).forEach(function (x) { printables[x.handle] = x; });
      ((r[1] && r[1].recipes) || []).forEach(function (x) { recipes[x.handle] = x; });
      if (!themes.length) return;
      var form = box.querySelector('[data-kk-party-form]'), out = box.querySelector('[data-kk-party-out]');
      form.querySelector('[data-kk-themes]').innerHTML = themes.map(function (t, i) {
        return '<label class="kk-chip"><input type="radio" name="theme" value="' + i + '"' + (i ? '' : ' checked') + '><span>' + esc(t.title) + '</span></label>';
      }).join('');
      var pickBox = document.createElement('div');
      pickBox.className = 'kk-row'; pickBox.style.marginTop = '12px';
      form.appendChild(pickBox);
      function picker(t) {
        var need = /pick one recipe/i.test(typeof t.per_guest === 'string' ? t.per_guest : '') && (t.recipes || []).length > 1;
        var key = need ? t.handle : '';
        if (pickBox.getAttribute('data-for') === key) return;
        pickBox.setAttribute('data-for', key);
        pickBox.innerHTML = need ? '<label>Recipe <select name="pick">' + t.recipes.map(function (h) {
          return '<option value="' + esc(h) + '">' + esc((recipes[h] || {}).title || h) + '</option>'; }).join('') + '</select></label>' : '';
      }
      function render() {
        var t = themes[+((form.querySelector('input[name="theme"]:checked') || {}).value || 0)];
        picker(t);
        var n = Math.max(1, Math.min(30, parseInt(form.elements.bakers.value, 10) || t.guests_min || 6));
        var band = form.elements.level.value;
        var html = '<div class="kk-print-area"><h2>' + esc(t.title) + ' for ' + n + ' bakers</h2><p>' + esc(t.summary || '') + '</p>';
        if (t.guests_max && n > t.guests_max) html += '<p class="kk-safety-note">This party works best with up to ' + esc(t.guests_max) + ' bakers. Think about two smaller groups.</p>';
        if (t.levels && t.levels.length && band && t.levels.indexOf(band) < 0) html += '<p class="kk-note">This theme is planned for ' + t.levels.map(function (b) { return BANDS[b] || b; }).join(', ') + '. Give a grown-up more of the jobs.</p>';
        if (t.image) html = '<img class="kk-article__img" src="' + esc(t.image) + '&width=1000" alt="" width="1000" height="667">' + html;
        var plan = (t.plan || []).slice().sort(function (a, b) { return b.minutes_before - a.minutes_before; });
        html += '<h3>Countdown plan</h3><ol class="kk-plan">' + plan.map(function (s) {
          var m = +s.minutes_before || 0;
          var when = m <= 0 ? 'Party time' : m >= 1260 ? 'The day before' : m >= 600 ? 'The night before' :
            m >= 60 ? (Math.round(m / 6) / 10) + ' hr before' : m + ' min before';
          return '<li><b>' + esc(when) + ': ' + esc(s.title) + '</b>' + esc(s.text) + '</li>';
        }).join('') + '</ol>';
        var lines = {}, order = [], recipeNotes = [];
        var pg = t.per_guest, pgText = typeof pg === 'string' ? pg : '';
        var pgNum = typeof pg === 'number' ? pg : ((pgText.match(/(\d+)/) || [])[1] || 0) * 1;
        var oneForGroup = /\bone cake\b|for the whole group/i.test(pgText);
        var list = t.recipes || [];
        if (/pick one recipe/i.test(pgText) && list.length > 1) {
          var pick = form.elements.pick && form.elements.pick.value;
          list = [list.indexOf(pick) >= 0 ? pick : list[0]];
        }
        if (pgText) html += '<p class="kk-note">' + esc(pgText) + '</p>';
        // "Plan on 2 popsicles and 1 small cup of strawberry milk for each guest": match each number to the recipes whose
        // yield unit or title shares a word with it; recipes sharing one number split it (2 popsicles across 2 flavors).
        var pairs = [], re = /(\d+)\s+([a-z][a-z ]*?)(?=\s+(?:and|for|,)|[,.]|$)/gi, mm;
        while ((mm = re.exec(pgText))) pairs.push({ n: +mm[1], words: mm[2].toLowerCase().split(/\s+/) });
        function stem(w) { return w.replace(/(es|s)$/, ''); }
        function pairFor(rec) {
          var hay = ((rec.yield_unit || '') + ' ' + (rec.title || '')).toLowerCase().split(/\W+/).map(stem);
          for (var i = 0; i < pairs.length; i++) {
            if (pairs[i].words.some(function (w) { return w.length > 3 && hay.indexOf(stem(w)) >= 0; })) return i;
          }
          return -1;
        }
        var share = {};
        list.forEach(function (h) { if (recipes[h]) { var i = pairFor(recipes[h]); share[i] = (share[i] || 0) + 1; } });
        list.forEach(function (h) {
          var rec = recipes[h], per = typeof pg === 'object' && pg ? pg[h] : pgNum;
          if (rec && typeof pg !== 'object') {
            var pi = pairFor(rec);
            if (pi >= 0) per = pairs[pi].n / (share[pi] || 1);
          }
          per = +per || 2;
          if (!rec) return;
          if (oneForGroup) {
            recipeNotes.push('<li><a href="' + esc(rec.url) + '">' + esc(rec.title) + '</a>: 1 batch for the whole group</li>');
            (rec.ingredient_lines || []).forEach(function (l) {
              var p = parseQty(l), key = (p ? p.rest : l).toLowerCase();
              if (!lines[key]) { lines[key] = { q: 0, rest: p ? p.rest : l, plain: !p }; order.push(key); }
              if (p) lines[key].q += p.q;
            });
            return;
          }
          if (rec.yield_n) {
            var batches = Math.max(1, Math.ceil(n * per / rec.yield_n));
            recipeNotes.push('<li><a href="' + esc(rec.url) + '">' + esc(rec.title) + '</a>: ' + batches + ' batch' + (batches > 1 ? 'es' : '') + ' (' + esc(rec.yield_n + ' ' + (rec.yield_n === 1 ? (rec.yield_unit || '').replace(/s$/, '') : (rec.yield_unit || ''))) + ' each)</li>');
            (rec.ingredient_lines || []).forEach(function (l) {
              var p = parseQty(l), key = (p ? p.rest : l).toLowerCase();
              if (!lines[key]) { lines[key] = { q: 0, rest: p ? p.rest : l, plain: !p }; order.push(key); }
              if (p) lines[key].q += p.q * batches;
            });
          } else {
            recipeNotes.push('<li><a href="' + esc(rec.url) + '">' + esc(rec.title) + '</a>: make one batch per ' + esc(per) + ' bakers</li>');
          }
        });
        html += '<h3>What to bake</h3><ul class="kk-list">' + recipeNotes.join('') + '</ul>';
        if (order.length) html += '<h3>Shopping and ingredient checklist</h3><ul class="kk-list">' + order.map(function (k) {
          var x = lines[k]; return '<li><label><input type="checkbox"> ' + esc((x.plain ? '' : fmtQty(x.q) + ' ') + x.rest) + '</label></li>';
        }).join('') + '</ul><p class="kk-guide">Amounts are added up from each recipe, so check the units (cups, grams, sticks) when they differ.</p>';
        if ((t.stations || []).length) html += '<h3>Stations</h3><ul class="kk-list">' + t.stations.map(function (s) { return '<li>' + esc(typeof s === 'string' ? s : (s.title || '') + (s.text ? ': ' + s.text : '')) + '</li>'; }).join('') + '</ul>';
        if ((t.decorating_templates || []).length) html += '<h3>Print these first</h3><ul class="kk-list">' + t.decorating_templates.map(function (h) {
          var pr = printables[h];
          return '<li><a href="/blogs/kids-kitchen/' + esc(h) + '">' + esc(pr ? pr.title : h.replace(/^printable-\d+-/, '').replace(/-/g, ' ')) + '</a></li>'; }).join('') + '</ul>';
        if ((t.grown_up_jobs || []).length) html += '<div class="kk-grownup"><h2>Grown-up jobs</h2><ul class="kk-list">' + t.grown_up_jobs.map(function (j) { return '<li>' + esc(j) + '</li>'; }).join('') + '</ul></div>';
        if (t.allergy_note) html += '<p class="kk-safety-note">' + esc(t.allergy_note) + '</p>';
        out.innerHTML = html + '</div><p class="kk-print-hide"><button type="button" class="kk-btn" data-kk-print>Print plan</button></p>';
      }
      form.addEventListener('change', render);
      form.addEventListener('input', function (e) { if (e.target.name === 'bakers') render(); });
      form.addEventListener('submit', function (e) { e.preventDefault(); render(); });
      box.hidden = false;
      render();
    }).catch(function () { /* page shows its intro */ });
  }

  /* ---------------- printables ---------------- */
  function wordSearch() {
    $$('[data-kk-wordsearch]').forEach(function (box) {
      var words = (box.getAttribute('data-kk-wordsearch') || '').split('|').map(function (w) { return w.toUpperCase().replace(/[^A-Z]/g, ''); })
        .filter(function (w) { return w.length > 1 && w.length <= 12; });
      var N = 12, rnd = seeded(box.getAttribute('data-seed') || 'kk'), g = [], dirs = [[0, 1], [1, 0], [1, 1], [-1, 1]];
      for (var i = 0; i < N; i++) { g.push([]); for (var j = 0; j < N; j++) g[i].push(''); }
      var placed = [];
      words.sort(function (a, b) { return b.length - a.length; }).forEach(function (w) {
        for (var tries = 0; tries < 300; tries++) {
          var d = dirs[Math.floor(rnd() * dirs.length)], r0 = Math.floor(rnd() * N), c0 = Math.floor(rnd() * N), ok = true;
          for (var k = 0; k < w.length; k++) {
            var r = r0 + d[0] * k, c = c0 + d[1] * k;
            if (r < 0 || r >= N || c >= N || (g[r][c] && g[r][c] !== w[k])) { ok = false; break; }
          }
          if (!ok) continue;
          for (k = 0; k < w.length; k++) g[r0 + d[0] * k][c0 + d[1] * k] = w[k];
          placed.push(w); return;
        }
      });
      var A = 'ABCDEFGHIJKLMNOPRSTUVWY';
      box.innerHTML = '<table class="kk-ws" aria-label="Word search">' + g.map(function (row) {
        return '<tr>' + row.map(function (ch) { return '<td>' + (ch || A[Math.floor(rnd() * A.length)]) + '</td>'; }).join('') + '</tr>';
      }).join('') + '</table><p><b>Find:</b> ' + placed.sort().join(', ') + '</p>';
    });
  }
  var SHAPES = {
    circle: '<circle cx="50" cy="50" r="42"/>',
    square: '<rect x="10" y="10" width="80" height="80" rx="4"/>',
    rectangle: '<rect x="6" y="24" width="88" height="52" rx="4"/>',
    triangle: '<polygon points="50,8 94,90 6,90"/>',
    star: '<polygon points="50,6 61,38 95,38 67,58 78,92 50,71 22,92 33,58 5,38 39,38"/>',
    heart: '<path d="M50 88 C10 60 4 34 22 20 C36 9 48 18 50 28 C52 18 64 9 78 20 C96 34 90 60 50 88 Z"/>',
    leaf: '<path d="M50 94 C18 70 14 32 50 6 C86 32 82 70 50 94 Z M50 94 L50 20"/>',
    flower: '<circle cx="50" cy="26" r="16"/><circle cx="74" cy="44" r="16"/><circle cx="65" cy="72" r="16"/><circle cx="35" cy="72" r="16"/><circle cx="26" cy="44" r="16"/><circle cx="50" cy="52" r="10"/>',
    moon: '<path d="M64 8 A44 44 0 1 0 92 70 A36 36 0 1 1 64 8 Z"/>',
    cupcake: '<path d="M24 50 L32 92 L68 92 L76 50 Z"/><path d="M18 50 C18 30 34 18 50 18 C66 18 82 30 82 50 Z"/>',
    butterfly: '<ellipse cx="30" cy="38" rx="22" ry="26"/><ellipse cx="70" cy="38" rx="22" ry="26"/><ellipse cx="34" cy="74" rx="16" ry="16"/><ellipse cx="66" cy="74" rx="16" ry="16"/><line x1="50" y1="20" x2="50" y2="90"/>'
  };
  function shapes() {
    $$('[data-kk-shapes]').forEach(function (box) {
      var list = [];
      (box.getAttribute('data-kk-shapes') || '').split(/[|,]/).forEach(function (s) {
        var m = s.trim().toLowerCase().match(/^([a-z ]+?)(?:\s*x\s*(\d+))?$/);
        if (!m) return;
        var raw = m[1].trim().replace(/s$/, ''), n = Math.min(24, parseInt(m[2] || '1', 10));
        var name = SHAPES[raw] ? raw : (Object.keys(SHAPES).filter(function (k) { return raw.indexOf(k) >= 0; })[0] || raw);
        for (var i = 0; i < n; i++) list.push(name);
      });
      box.innerHTML = list.map(function (name) {
        return '<svg viewBox="0 0 100 100" role="img" aria-label="' + esc(name) + ' outline" fill="none" stroke="#000" stroke-width="2" stroke-dasharray="5 4">' +
          (SHAPES[name] || SHAPES.circle) + '</svg>';
      }).join('');
    });
  }
  function printButtons() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-kk-print]');
      if (!b) return;
      document.body.classList.add('kk-print-sheet');
      track('kk_print', { kind: b.getAttribute('data-kk-print') || 'page' });
      window.print();
    });
    window.addEventListener('afterprint', function () { document.body.classList.remove('kk-print-sheet', 'kk-printing'); var c = document.getElementById('kk-printcard'); if (c) c.remove(); });
  }

  /* ---------------- recipe box: step by step + kids' print card ---------------- */
  var HOT = /\b(oven|ovens|stove|stovetop|burner|knife|knives|mixer|blender|food processor|boil|boiling|simmer|hot|microwave|fry|broil|caramel)\b/i;
  function stepTexts() { return $$('.recipe-article__steps li').map(function (li) { return li.textContent.replace(/\s+/g, ' ').trim(); }).filter(Boolean); }
  function timerMinutes(t) {
    var m = t.match(/(\d+)(?:\s*(?:to|-|or)\s*\d+)?\s*(?:minutes?|mins?)\b/i);
    if (m) return +m[1];
    m = t.match(/(\d+)(?:\s*(?:to|-|or)\s*\d+)?\s*hours?\b/i);
    return m ? +m[1] * 60 : 0;
  }
  function stepMode(btn) {
    var steps = stepTexts();
    if (!steps.length) return;
    var i = 0, timer = null, left = 0, lastFocus = document.activeElement;
    var ov = document.createElement('div');
    ov.className = 'kk-step'; ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true'); ov.setAttribute('aria-label', 'Step by step');
    ov.innerHTML = '<div class="kk-step__top"><span data-count></span><button type="button" data-close>Close</button></div>' +
      '<div class="kk-step__body"><span class="kk-step__badge" data-badge hidden>\ud83e\uddd1\u200d\ud83c\udf73 Grown-up job</span><p class="kk-step__text" data-text aria-live="polite"></p>' +
      '<div class="kk-row"><button type="button" data-say>\ud83d\udd0a Read aloud</button><button type="button" data-timer hidden></button><span class="kk-step__timer" data-left></span></div></div>' +
      '<div class="kk-step__nav"><button type="button" data-prev>Back</button><button type="button" class="kk-step__go" data-next>Next step</button></div>';
    document.body.appendChild(ov);
    var q = function (s) { return ov.querySelector(s); };
    function stopTimer() { if (timer) clearInterval(timer); timer = null; q('[data-left]').textContent = ''; }
    function draw() {
      var t = steps[i];
      q('[data-count]').textContent = 'Step ' + (i + 1) + ' of ' + steps.length;
      q('[data-text]').textContent = t;
      q('[data-badge]').hidden = !HOT.test(t);
      var m = timerMinutes(t), tb = q('[data-timer]');
      tb.hidden = !m; tb.textContent = 'Start timer: ' + m + ' min';
      tb.setAttribute('data-m', m);
      q('[data-prev]').disabled = i === 0;
      q('[data-next]').textContent = i === steps.length - 1 ? 'All done!' : 'Next step';
      stopTimer();
    }
    function close() {
      stopTimer();
      try { window.speechSynthesis.cancel(); } catch (e) {}
      ov.remove(); document.removeEventListener('keydown', keys);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function keys(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight' && i < steps.length - 1) { i++; draw(); }
      else if (e.key === 'ArrowLeft' && i > 0) { i--; draw(); }
    }
    ov.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) close();
      else if (e.target.closest('[data-prev]') && i > 0) { i--; draw(); }
      else if (e.target.closest('[data-next]')) { if (i < steps.length - 1) { i++; draw(); } else close(); }
      else if (e.target.closest('[data-say]')) {
        try { window.speechSynthesis.cancel(); var u = new SpeechSynthesisUtterance(steps[i]); u.rate = 0.95; window.speechSynthesis.speak(u); } catch (er) {}
      } else if (e.target.closest('[data-timer]')) {
        stopTimer(); left = (+e.target.closest('[data-timer]').getAttribute('data-m')) * 60;
        var show = function () { q('[data-left]').textContent = Math.floor(left / 60) + ':' + ('0' + (left % 60)).slice(-2); };
        show();
        timer = setInterval(function () { left--; show(); if (left <= 0) { stopTimer(); q('[data-left]').textContent = 'Time\u2019s up!'; } }, 1000);
      }
    });
    document.addEventListener('keydown', keys);
    draw();
    q('[data-next]').focus();
    track('kk_step_mode', { steps: steps.length });
  }
  function printCard(box) {
    var title = ($('.recipe-article h1, h1') || {}).textContent || document.title;
    var ings = $$('.recipe-article__ing').map(function (li) { return $$('.recipe-article__ing-qty, .recipe-article__ing-name', li).map(function (s) { return s.textContent; }).join(' ').replace(/\s+/g, ' ').replace(/\(\s*[\d.]+\s*g\s*\)/g, '').trim(); });
    var steps = stepTexts();
    var c = document.createElement('div');
    c.id = 'kk-printcard';
    c.innerHTML = '<h1>' + esc(title.trim()) + '</h1><p><b>Level:</b> ' + esc(box.getAttribute('data-band-label') || '') + '</p>' +
      (box.getAttribute('data-kid-jobs') ? '<p><b>Kids do:</b> ' + esc(box.getAttribute('data-kid-jobs')) + '</p>' : '') +
      '<p><b>Grown-up jobs:</b> ' + esc(box.getAttribute('data-grownup-label') || 'bake together with a grown-up nearby') + '</p>' +
      (ings.length ? '<h2>You need</h2><ul>' + ings.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '') +
      '<h2>Steps</h2><ol>' + steps.map(function (s) { return '<li>' + (HOT.test(s) ? '<b>[Grown-up]</b> ' : '') + esc(s) + '</li>'; }).join('') + '</ol>' +
      '<p>Wash your hands first. No tasting raw dough or batter. From vanillagoods.com Kids Kitchen.</p>';
    document.body.appendChild(c);
    document.body.classList.add('kk-printing');
    track('kk_print', { kind: 'recipe_card' });
    window.print();
  }
  function recipeBox() {
    var box = $('[data-kk-recipebox]');
    if (!box) return;
    if (!stepTexts().length) { $$('[data-kk-stepmode],[data-kk-printcard]', box).forEach(function (b) { b.hidden = true; }); return; }
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-kk-stepmode]')) stepMode();
      if (e.target.closest('[data-kk-printcard]')) printCard(box);
    });
  }

  function init() {
    videos(); tabs(); levelFilters(); hub(); rememberLesson(); math(); party(); wordSearch(); shapes(); printButtons(); recipeBox();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
